module.exports = __webpack_public_path__ + "static/media/arrow-down-icon.cf63e7bb.svg";